import { render, staticRenderFns } from "./OriginInfo.vue?vue&type=template&id=13b6d074&scoped=true"
import script from "./OriginInfo.vue?vue&type=script&lang=js"
export * from "./OriginInfo.vue?vue&type=script&lang=js"
import style0 from "./OriginInfo.vue?vue&type=style&index=0&id=13b6d074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b6d074",
  null
  
)

export default component.exports